export { default } from './LocalizedDefaultSeo';
